// extracted by mini-css-extract-plugin
export default {"preparation_instruction":"Instruction_preparation_instruction__p4NFG"};